import { alpha, Stack } from '@rossum/ui/material';
import { GridRow, GridRowProps } from '@rossum/ui/x-data-grid-pro';
import { TransformedAnnotation } from '../../document-list-columns/hooks/useTransformAnnotation';
import { DisabledRow } from '../../pricing/components/DisabledRow';

export const CustomRow = ({
  selectedAnnotationId,
  ...props
}: Omit<GridRowProps, 'row'> & {
  row?: TransformedAnnotation;
  selectedAnnotationId: number | undefined;
}) => {
  const { row } = props;
  return row ? (
    row.restricted_access ? (
      <DisabledRow {...props} row={row} />
    ) : row.id === selectedAnnotationId ? (
      <Stack
        sx={{
          backgroundColor: t => alpha(t.palette.common.white, 0.2),
          fontWeight: t => t.typography.fontWeightBold,
        }}
      >
        <GridRow {...props} row={row} />
      </Stack>
    ) : (
      <GridRow {...props} row={row} />
    )
  ) : null;
};
